<template>
  <div id="app">
    <router-view></router-view>
    <login></login>
  </div>
</template>

<script>
  export default {
    mounted() {
      switch(this.$EpetJs.Const.ENV){
        case 'local':
        case 'dev':
          var iframe = document.createElement('iframe')
          iframe.setAttribute('src',this.$EpetJs.Const.PROTOCOL+'//sso.dev.tapinpet.com/index/index.html')
          iframe.setAttribute('id','ssoLogin')
          iframe.style.display = 'none'
          document.body.appendChild(iframe)
          break
        default:
          var iframe = document.createElement('iframe')
          iframe.setAttribute('src',this.$EpetJs.Const.PROTOCOL+'//sso.tapinpet.com/index/index.html')
          iframe.setAttribute('id','ssoLogin')
          iframe.style.display = 'none'
          document.body.appendChild(iframe)
      }
    }
  }
</script>


<style>
  @import './assets/css/public.css';
</style>
<style lang="less">
  *{
    padding:0;
    margin:0;
  }
  #app,html,body{
    width:100%;
    height:100%;
    overflow:hidden;
  }
</style>
